<div *ngIf="!listDisplay">
  <div *ngIf="!display">
    <div class="content-wrapper question-type-radioButtion">
      <div class="btn-wrapper">
        <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
          <span>{{'questions.typeOfQuestAiDriven.btnBack' | translate}}</span>
        </button>
      </div>

      <form [formGroup]="questionForm">
        <div class="Q-section">
          <div class="container-fluid border">
            <div class="row Question">
              <div class="col-sm-1">
                {{'questions.typeOfQuestAiDriven.questionSection1.label1' | translate}}</div>
              <div class="col-sm-1">
                <input type="number" min="1" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                  value="" class="form-control" formControlName="numberOfQuestions">
              </div>
              <div class="col-md-6">{{questionTypeName}}</div>
            </div>
            <div class="row error-msg Question">
              <mat-error *ngIf="questionForm.controls.numberOfQuestions.errors?.min && questionForm.get('numberOfQuestions').touched">
                {{'questions.typeOfQuestAiDriven.questionSection1.errMsg1' | translate}}</mat-error>
            </div>

            <div class="row Question"
              *ngIf="questionSubTypeId != QuestionSubTypeIdEnum.Descriptive && questionSubTypeId != QuestionSubTypeIdEnum.MultipleChoiceYesOrNo">
              <div class="col-sm-1">
                {{'questions.typeOfQuestAiDriven.questionSection1.label3' | translate}}</div>
              <div class="col-sm-1">
                <input type="number" min="{{minOption}}" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}" formControlName="optionCount"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                  value="" class="form-control" [disabled]="disableOptionCount">
              </div>
              <div class="col-md-6">
                {{'questions.typeOfQuestAiDriven.questionSection1.label4' | translate}}</div>
            </div>
            <div class="row error-msg Question">
              <mat-error *ngIf="questionForm.controls.optionCount.errors?.min && questionForm.get('optionCount').touched">
                {{'questions.typeOfQuestAiDriven.questionSection1.errMsg2' | translate}}</mat-error>
            </div>
            <div class="row Question"
              *ngIf="questionSubTypeId != QuestionSubTypeIdEnum.Descriptive && questionSubTypeId != QuestionSubTypeIdEnum.MultipleChoiceStandard && questionSubTypeId != QuestionSubTypeIdEnum.MultipleChoiceYesOrNo && questionSubTypeId != QuestionSubTypeIdEnum.FillInTheBlanks">
              <div class="col-sm-1">
                {{'questions.typeOfQuestAiDriven.questionSection1.label5' | translate}}</div>
              <div class="col-sm-1">
                <input type="number" min="1" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                  value="" class="form-control" formControlName="responseCount" (change)="onCheck()">
              </div>
              <div class="col-md-6" *ngIf="questionSubTypeId != QuestionSubTypeIdEnum.FillInTheBlanks">
                {{'questions.typeOfQuestAiDriven.questionSection1.label6' | translate}}
              </div>
            </div>

            <div class="row Question" *ngIf="questionSubTypeId === QuestionSubTypeIdEnum.FillInTheBlanks">
              <div class="col-sm-1">
                {{'questions.typeOfQuestAiDriven.questionSection1.label5' | translate}}</div>
              <div class="col-sm-1">
                <input type="number" min="0" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                  value="" class="form-control" formControlName="numberOfBlank">
              </div>
              <div class="col-md-6">{{'questions.typeOfQuestAiDriven.questionSection1.label7' | translate}}</div>
            </div>
          </div>
        </div>


        <div class="Q-section">
          <div class="container-fluid border">
            <section style="height: auto; margin-bottom: 20px;">
              <div class="row Question">
                <div class="col-sm-1">
                  <span>{{'questions.typeOfQuestAiDriven.questionSection2.label' | translate}}</span>
                </div>
                <div class="col-sm-11">
                  <mat-radio-group aria-labelledby="example-radio-group-label" class="option-group" formControlName="itemStrategy"
                    (change)="resetStrategy()">
                    <mat-radio-button value="sample_question" class="option-group" selected>
                      {{'questions.typeOfQuestAiDriven.questionSection2.option1' | translate}}
                    </mat-radio-button>
                    <mat-radio-button value="standard_question" class="option-group">
                      {{'questions.typeOfQuestAiDriven.questionSection2.option2' | translate}}
                    </mat-radio-button>
                    <mat-radio-button value="reference_question" class="option-group">
                      {{'questions.typeOfQuestAiDriven.questionSection2.option3' | translate}}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
              <ng-container *ngIf="questionForm.get('itemStrategy').value == 'sample_question'">
                <textarea class="form-control referenceText" rows="4" cols="20" placeholder=" {{'questions.typeOfQuestAiDriven.questionChoice.sampleQuest.placeholder' | translate}}" formControlName="referenceText"></textarea>
              </ng-container>

             <ng-container *ngIf="questionForm.get('itemStrategy').value == 'standard_question'">
                <div class="body-section1 title">
                  <div class="itemStatagy" *ngIf="strategyData && strategyData.length">
                    <div class="itemStatagyItem d-flex align-items-center"
                    *ngFor="let item of strategyData; let i = index">
                      <p style="max-width: 500px; word-wrap: break-word;">{{item.StrategyName}} : {{item.value}}</p>
                      <mat-icon class="close-icon" (click)="removeStrategy(i)">close</mat-icon>
                    </div>
                    <button mat-flat-button class="btn-primary" style="margin-bottom: 10px; height: 40px;" color="" aria-label="Back" (click)='addStrategy()'>
                      <span>{{'questions.typeOfQuestAiDriven.questionChoice.criteria.btnAddStrategy' | translate}}</span>
                    </button>
                  </div>
                  <button *ngIf="strategyData && strategyData.length == 0" mat-flat-button class="btn-primary" color="" aria-label="Back" (click)='addStrategy()'>
                    <span>{{'questions.typeOfQuestAiDriven.questionChoice.criteria.btnAddStrategy' | translate}}</span>
                  </button>
                </div>
              </ng-container>

              <ng-container *ngIf="questionForm.get('itemStrategy').value == 'reference_question'">
                <textarea class="form-control referenceText" rows="4" maxlength="2049" placeholder="{{'questions.typeOfQuestAiDriven.questionChoice.referenceText.placeholder' | translate}}" formControlName="referenceText"></textarea>
                <span style="color:red"
                  *ngIf="questionForm.get('referenceText').value && questionForm.get('referenceText').value.length >= 2049">{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.errMsg1' | translate}}</span>
              </ng-container>
            </section>
          </div>
        </div>
      </form>

      <div class="Q-section">
        <div class="container-fluid border">
          <section style="height: 150px;">
            <div class="row Question">
              <div class="col-sm-2">
                {{'questions.typeOfQuestAiDriven.questionSection3.label' | translate}}
              </div>

              <div class="col-sm-4">
                <mat-slide-toggle class="example-margin" [(ngModel)]="FactorRules" [ngModelOptions]="{standalone: true}" [disabled]="true">
                </mat-slide-toggle>
              </div>
            </div>

            <div class="btn-wrapper">
              <div class="row Question" style="margin-left: -5px;">
                <!-- <div class="col-lg-6"> -->
                  <button mat-flat-button class="btn-warn" (click)='generateQuestion()'
                  [disabled]="questionForm.invalid ||
                  (questionForm.get('itemStrategy').value == 'reference_question' && questionForm.get('referenceText').value.length >= 2049)">
                    <span>{{'questions.typeOfQuestAiDriven.questionSection3.btnGenerate' | translate}}</span>
                  </button> &nbsp;&nbsp;&nbsp;
                <!-- </div> -->
                <!-- <div class="col-lg-6"> -->
                  <button mat-flat-button class="btn-back" (click)='reset()'>
                    <span>{{'questions.typeOfQuestAiDriven.questionSection3.btnReset' | translate}}</span>
                  </button>
                <!-- </div> -->
              </div>
            </div>
          </section>

          <div class="body-section title" *ngIf="this.userForm.get('questionArray').value.length > 0">
            <span>{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.labelAIGenerate' | translate}}</span>
          </div>
          <br><br>
          <form [formGroup]="userForm" *ngIf="this.userForm.get('questionArray').value.length > 0">
            <section formArrayName="questionArray">
              <div class="row" *ngFor="let question of userForm.get('questionArray')['controls']; let i=index" [formGroupName]="i">
                <div class="row">
                  <div class="checkbox m-0">
                    <mat-checkbox formControlName="isSelected" (change)="toggleCheckbox()"></mat-checkbox>&nbsp;&nbsp;
                  </div>

                  <!-- Question description section-->
                  <div class="column2">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="div-content sentence-align">
                          <ng-component [innerHTML]="question.get('questiondescription').value.description">
                          </ng-component>
                        </div>
                      </div>
                      <div class="col-md-6"></div>
                    </div>
                  </div>

                  <!-- Question types section-->
                  <div class="column1">
                    <div class="row">
                      <div class="col-md-4 answers-label">
                        <div class="moreOptions">
                          <label class="Questions-score">{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.labelTestScore' | translate}}<span class="error" *ngIf="questionSubTypeId == QuestionSubTypeIdEnum.Descriptive">*</span></label>
                          <!-- <input min="0" [value]="question.get('newEvent').value" type="number" style="max-width: 120px;"
                            onkeyup="if(this.value.length == 6 ) return false;" class="form-control scoreInput"
                            [disabled]="questionSubTypeId != QuestionSubTypeIdEnum.Descriptive" formControlName="correctPoints"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->
                        </div>
                        <input type="number" min="0" max="9999.99" step=".01" style="max-width: 120px;" [value]="question.get('newEvent').value"
                        formControlName="correctPoints" class="form-control scoreInput"
                        [disabled]="questionSubTypeId != QuestionSubTypeIdEnum.Descriptive"
                        (input)="validateInput($event, question, 'options')" (keypress)="omit_special_char($event)">
                      </div>
                      <div class="col-md-4 answers-label" *ngIf="questionSubTypeId == QuestionSubTypeIdEnum.Descriptive">
                        <div class="moreOptions">
                          <label>{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.labelCharLimit' | translate}}<span class="error">*</span></label>
                          <input min="0" class="form-control" type="number" max="32000"
                            formControlName="maximumcharacterForFreetext" style="max-width: 120px;"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
                          <mat-error *ngIf="question.get('maximumcharacterForFreetext').value >= 32001">{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.errMsg1' | translate}}</mat-error>
                        </div>
                      </div>
                    </div>

                    <!-- // multiple choice  -->
                    <ng-container *ngIf="questionSubTypeId == QuestionSubTypeIdEnum.MultipleChoiceOptions">
                      <div class="score-wrapper" formArrayName="options">
                        <label class="mrg-top">{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.labelSetScore' | translate}}<span class="error">*</span></label>
                        <div class="add-option" *ngFor="let o of question.get('options')['controls']; let j = index" [formGroupName]="j">
                          <div class="input-class-container">
                            <mat-checkbox formControlName="answerValid" [checked]="o.get('answerValid').value"
                              (change)="addScore(question.get('options')['controls'], o)">
                            </mat-checkbox>
                            <input type="number" class="form-control" formControlName="correctPoints" min="0" max="9999.99" step=".01"
                            (change)="addScore(question.get('options')['controls'], o)" (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">

                              <!-- <input type="number" min="0" max="9999" step=".01"
                              formControlName="correctPoints"
                              (change)="addScore(question.get('options')['controls'], o)"
                              class="form-control"
                              onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                              (keypress)="omit_special_char($event)"
                              (keyup)="replace2Decimal($event, o, 'options')"> -->
                            <ng-component [innerHTML]="o.get('answerDescription').value.description">
                            </ng-component>
                            <!-- <div class="drag-box" *cdkDragPreview>
                              <span [innerHtml]="o.get('answerDescription').value.description"></span>
                            </div> -->
                          </div>
                        </div>
                        <!-- <mat-error *ngIf="!question.get('correctAns').value"> Correct answer is not coming from AI API.</mat-error> -->
                      </div>
                    </ng-container>
                    <!-- single choice -->
                    <ng-container *ngIf="questionSubTypeId == QuestionSubTypeIdEnum.MultipleChoiceStandard">
                      <div class="score-wrapper" formArrayName="options">
                        <label class="mrg-top">{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.labelSetScore' | translate}}<span class="error">*</span></label>
                        <div class="add-option" *ngFor="let o of question.get('options')['controls']; let j = index" [formGroupName]="j">
                          <div class="input-class-container">
                            <mat-radio-button class="radio-btn-class" type="radio" id="o{{i}}{{j}}" name="o{{i}}" [checked]="o.get('answerValid').value"
                              (change)="onCheckRadioOption(question.get('options')['controls'], o)">
                            </mat-radio-button>
                            <input type="number" class="form-control" formControlName="correctPoints" min="0" max="9999.99" step=".01"
                            (change)="addScore(question.get('options')['controls'], o)" (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">

                              <!-- <input type="number" min="0" max="9999" step=".01"
                              formControlName="correctPoints"
                              (change)="addScore(question.get('options')['controls'], o)"
                              class="form-control"
                              onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                              (keypress)="omit_special_char($event)"
                              (keyup)="replace2Decimal($event, o, 'options')"> -->
                            <ng-component [innerHTML]="o.get('answerDescription').value.description">
                            </ng-component>
                            <!-- <div class="drag-box" *cdkDragPreview>
                              <span [innerHtml]="o.get('answerDescription').value.description"></span>
                            </div> -->
                          </div>
                        </div>
                        <!-- <mat-error *ngIf="!question.get('correctAns').value"> Correct answer is not coming from AI API.</mat-error> -->
                      </div>
                    </ng-container>

                    <!-- true false -->
                    <ng-container *ngIf="questionSubTypeId == QuestionSubTypeIdEnum.MultipleChoiceYesOrNo">
                      <div class="score-wrapper" formArrayName="options">
                        <label class="mrg-top">{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.labelSetScore' | translate}}<span class="error">*</span></label>
                        <div class="add-option" *ngFor="let o of question.get('options')['controls']; let j = index" [formGroupName]="j">
                          <div class="input-class-container">
                            <mat-radio-button class="radio-btn-class" type="radio" id="o{{i}}{{j}}" name="o{{i}}" [checked]="o.get('answerValid').value"
                              (change)="onCheckRadioOption(question.get('options')['controls'], o)">
                            </mat-radio-button>
                            <input type="number" class="form-control" formControlName="correctPoints" min="0" max="9999.99" step=".01"
                            (change)="addScore(question.get('options')['controls'], o)" (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">

                              <!-- <input type="number" min="0" max="9999" step=".01"
                              formControlName="correctPoints"
                              (change)="addScore(question.get('options')['controls'], o)"
                              class="form-control"
                              onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                              (keypress)="omit_special_char($event)"
                              (keyup)="replace2Decimal($event, o, 'options')"> -->
                            <ng-component [innerHTML]="o.get('answerDescription').value.description">
                            </ng-component>
                            <div class="drag-box" *cdkDragPreview>
                              <span [innerHtml]="o"></span>
                            </div>
                          </div>
                        </div>
                        <!-- <mat-error *ngIf="!question.get('correctAns').value"> Correct answer is not coming from AI API.</mat-error> -->
                      </div>
                    </ng-container>

                    <!-- fill in the blank -->
                    <ng-container *ngIf="questionSubTypeId == QuestionSubTypeIdEnum.FillInTheBlanks">
                      <div class="score-wrapper" formArrayName="options">
                        <label class="mrg-top">{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.labelSetScore' | translate}}<span class="error">*</span></label>
                        <div class="add-option" *ngFor="let o of question.get('options')['controls']; let j = index" [formGroupName]="j">
                          <div class="input-class-container">
                            <div class="remove-inputs d-flex align-items-center">
                              <span>{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.answer' | translate}} {{j+1}}<span class="error"><strong>*</strong></span></span>
                              <input type="number" class="form-control option-number" formControlName="correctPoints" min="0" max="9999.99" step=".01"
                              (change)="addScoreForFIB(question.get('options')['controls'], i)" (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">

                              <!-- <input type="number" min="0" max="9999" step=".01"
                              formControlName="correctPoints"
                              (change)="addScoreForFIB(question.get('options')['controls'], i)"
                              class="form-control option-number"
                              onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                              (keypress)="omit_special_char($event)"
                              (keyup)="replace2Decimal($event, o, 'options')"> -->
                              <div class="ansDesc" formGroupName="answerDescription">
                                <input formControlName='description' class="form-control " type="text">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <!-- descriptive q -->
                    <ng-container *ngIf="questionSubTypeId == QuestionSubTypeIdEnum.Descriptive">
                      <div class="score-wrapper" formGroupName="answerDescription">
                        <textarea class="form-control description" rows="4" formControlName="description" readonly></textarea>
                      </div>
                    </ng-container>
                  </div>

                  <!-- More details section -->
                  <div class="column3">
                    <div class="row d-flex align-items-center" style="padding-bottom: 45px;">
                      <div class="col-md-4 answers-label">
                        <div class="moreOptions">
                          <label class="Questions-score">{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.labelMore' | translate}}</label>
                          <br><br>
                          <div class="scoring-check" *ngIf="questionSubTypeId != QuestionSubTypeIdEnum.Descriptive">
                            <mat-checkbox name="autoscoring" formControlName="autoScoring" [checked]="question.get('autoScoring').value"
                              [disabled]="true"><b>{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.moreOptions.checkbox' | translate}}</b>
                            </mat-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row d-flex align-items-center" style="margin-bottom: -10px; margin-top: -30px;">
                      <div class="col-md-4 form-label">
                        {{'questions.typeOfQuestAiDriven.aiGeneratedQuest.moreOptions.label1' | translate}}
                      </div>
                      <div class="col-md-4">
                        <ng-container *ngIf="questionSubTypeId == 2; then defaultPartialMatch; else defaultExactMatch"></ng-container>
                        <ng-template #defaultPartialMatch>
                          <mat-form-field class="scoring-type" appearance="fill" [hideRequiredMarker]="true" [floatLabel]="'auto'">
                            <mat-select formControlName="scoringTypeExactMatch"
                              [disabled]="questionSubTypeId == QuestionSubTypeIdEnum.MultipleChoiceStandard || questionSubTypeId == QuestionSubTypeIdEnum.MultipleChoiceYesOrNo || question.get('options')['controls'].length == 1">
                              <mat-option value="false">{{scoringType[0]?.title}}</mat-option>
                              <mat-option value="true">{{scoringType[1]?.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-template>
                        <ng-template #defaultExactMatch>
                          <mat-form-field class="scoring-type" appearance="fill" [hideRequiredMarker]="true" [floatLabel]="'auto'">
                            <mat-select formControlName="scoringTypeExactMatch"
                              [disabled]="questionSubTypeId == QuestionSubTypeIdEnum.MultipleChoiceStandard || questionSubTypeId == QuestionSubTypeIdEnum.MultipleChoiceYesOrNo || question.get('options')['controls'].length == 1">
                              <mat-option value="true">{{scoringType[0]?.title}}</mat-option>
                              <mat-option value="false">{{scoringType[1]?.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-template>
                      </div>
                    </div>

                    <div class="row d-flex align-items-center"
                      *ngIf="questionSubTypeId != QuestionSubTypeIdEnum.FillInTheBlanks && questionSubTypeId != QuestionSubTypeIdEnum.Descriptive">
                      <div class="col-md-4 form-label">
                        {{'questions.typeOfQuestAiDriven.aiGeneratedQuest.moreOptions.label2' | translate}}
                      </div>
                      <div class="col-md-4">
                        <mat-form-field class="scoring-type" appearance="fill">
                          <mat-select formControlName="questiondisplayoptions">
                            <mat-option value="Vertical">Vertical</mat-option>
                            <mat-option value="Horizontal">Horizontal</mat-option>
                            <!-- <mat-option [value]="orientation[0].title">
                              {{orientation[0].title}}</mat-option>
                            <mat-option [value]="orientation[1].title">
                              {{orientation[1].title}}</mat-option> -->
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="row d-flex align-items-center" style="margin-top: 8px;">
                      <div class="col-md-4 form-label">
                        {{'questions.typeOfQuestAiDriven.aiGeneratedQuest.moreOptions.label3' | translate}}
                      </div>
                      <div class="col-md-4">
                        <input min="0" [attr.disabled]="true" type="number" formControlName="penaltyPoints" class="form-control penalty-points"
                          type="number" min="0" max="9999" onkeypress="if(this.value.length == 4 ) return false;">
                      </div>
                    </div>

                    <div class="row d-flex align-items-center" style="margin-top: 20px;">
                      <div class="col-md-4 form-label">
                        {{'questions.typeOfQuestAiDriven.aiGeneratedQuest.moreOptions.label4' | translate}}
                      </div>
                      <div class="col-md-4">
                        <input type="number" min="0" max="9999.99" step=".01"
                        formControlName="minScoreIfAttempt" class="form-control penalty-points"
                        [ngClass]="{ 'is-invalid': submitted && userForm.controls.minimumScoreIfAttempt.errors }"
                        (input)="validateInput($event, question, 'minimumScore')" (keypress)="omit_special_char($event)">
                        <div *ngIf="submitted && userForm.controls.minimumScoreIfAttempt.errors" class="invalid-feedback">
                          <div *ngIf="userForm.controls.minimumScoreIfAttempt.errors.required">Field is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
              </div>
            </section>
          </form>

          <div class="btn-wrapper1" *ngIf="this.userForm.get('questionArray').value.length > 0">
            <button mat-flat-button class="btn-back btn-primary" color="" aria-label="Back" (click)='addQuestions()'
              [disabled]="userForm.invalid || selected.length == 0 || selected.length == undefined">
              <span>{{'questions.typeOfQuestAiDriven.aiGeneratedQuest.btnAddQuest' | translate}}</span>
            </button>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="display">
    <app-choose-question-type></app-choose-question-type>
  </div>
</div>

<div *ngIf="listDisplay">
  <app-question-list></app-question-list>
</div>


<add-strategy #standardStrategy></add-strategy>
